/*
* <license header>
*/

import React from 'react'
import {
  View,
  Flex,
  Heading,
  Text,
  TextField,
  Button,
  Form
} from '@adobe/react-spectrum'

const MOCK_CAPABILITIES = [
  { key: 'aiAssistant', title: 'AI Assistant', description: 'Chat completions and development guidance', enabled: true },
  { key: 'rag', title: 'RAG / Documentation', description: 'Retrieval-augmented generation for Adobe docs', enabled: true },
  { key: 'vibeCoding', title: 'Vibe coding', description: 'Code generation and agentic workflows', enabled: true },
  { key: 'langchain', title: 'LangChain agents', description: 'Agent orchestration and tracing', enabled: false }
]

export const OtherCredentialsConfigSection = () => (
  <View
    UNSAFE_style={{
      border: '1px solid var(--card-border)',
      borderRadius: '8px',
      padding: '1.25rem',
      backgroundColor: 'var(--white)'
    }}
    marginBottom="size-300"
  >
    <Heading level={2} UNSAFE_style={{ margin: 0, marginBottom: '0.5rem', fontSize: '1.125rem' }}>
      Other credentials
    </Heading>
    <Text UNSAFE_style={{ color: 'var(--gray-600)', fontSize: '0.875rem', marginBottom: '1rem' }}>
      Configure API keys for the AI layer: LLM providers for the assistant and vibe coding, LangChain for agent orchestration, and RAG for documentation search. At least one LLM provider is required for the AI Assistant.
    </Text>

    <Form necessityIndicator="label">
      <Flex direction="column" gap="size-200" marginBottom="size-300">
        <TextField
          label="OpenAI API Key"
          placeholder="sk-xxxxxxxxxxxxxxxx"
          type="password"
          width="size-4600"
          maxWidth="100%"
          description="For ChatGPT/GPT models. Used by the AI Assistant and vibe-coding engine."
        />
        <TextField
          label="Anthropic API Key"
          placeholder="sk-ant-xxxxxxxxxxxxxxxx"
          type="password"
          width="size-4600"
          maxWidth="100%"
          description="Optional. For Claude models as an alternative LLM provider."
        />
        <TextField
          label="LangSmith API Key"
          placeholder="lsv2_xxxxxxxxxxxxxxxx"
          type="password"
          width="size-4600"
          maxWidth="100%"
          description="Optional. For LangChain observability and agent tracing."
        />
        <TextField
          label="Pinecone API Key"
          placeholder="xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx"
          type="password"
          width="size-4600"
          maxWidth="100%"
          description="Optional. For RAG vector store (documentation embeddings)."
        />
      </Flex>

      <Flex gap="size-200" justifyContent="end">
        <Button variant="secondary">Test connection</Button>
        <Button variant="accent">Save</Button>
      </Flex>
    </Form>

    <View marginTop="size-400">
      <Heading level={3} UNSAFE_style={{ margin: 0, marginBottom: '0.75rem', fontSize: '1rem', fontWeight: 600 }}>
        AI layer capabilities
      </Heading>
      <Flex gap="size-200" wrap>
        {MOCK_CAPABILITIES.map(({ key, title, description, enabled }) => (
          <View
            key={key}
            UNSAFE_style={{
              border: `1px solid ${enabled ? 'var(--color-border-positive)' : 'var(--card-border)'}`,
              borderRadius: '8px',
              padding: '1rem',
              backgroundColor: enabled ? 'rgba(38, 142, 108, 0.08)' : 'var(--gray-75)',
              minWidth: '180px',
              flex: '1 1 180px'
            }}
          >
            <View
              UNSAFE_style={{
                width: 8,
                height: 8,
                borderRadius: '50%',
                backgroundColor: enabled ? 'var(--color-background-positive)' : 'var(--gray-400)'
              }}
            />
            <Text UNSAFE_style={{ fontWeight: 600, fontSize: '0.875rem', display: 'block', marginTop: '0.25rem' }}>
              {title}
            </Text>
            <Text UNSAFE_style={{ color: 'var(--gray-600)', fontSize: '0.75rem', marginTop: '0.25rem' }}>
              {description}
            </Text>
          </View>
        ))}
      </Flex>
    </View>
  </View>
)
